import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FileText, Search } from "lucide-react";
import "./Editorial.css";

/* Mobile-only sticky action bar for the candidate landing.
   Appears after the hero; hierarchy flips vs the hero (CV primary here —
   whoever is still scrolling has seen the jobs). Respects safe-area inset. */
export default function StickyApplyBar() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow((window.scrollY || 0) > 560);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className={`sticky-apply ${show ? "is-visible" : ""}`}>
      <Link to="/candidates/apply" className="sticky-apply__primary" tabIndex={show ? 0 : -1}>
        <FileText size={17} strokeWidth={2.2} /> Submit your CV
      </Link>
      <Link to="/candidates/jobs" className="sticky-apply__ghost" tabIndex={show ? 0 : -1}>
        <Search size={17} strokeWidth={2.2} /> Jobs
      </Link>
    </div>
  );
}
